import React from 'react';
import ProductItemView from '../ProductItemView';
import logging from '../../resource/middleware/logging.svg';

const Logging = () => {
    return (
        <ProductItemView
            title="Logging avanzado"
            items={["Garantía de trazabilidad completa", "Niveles de trazabilidad: alertas, debug, etc "]}
            image={logging}
            centered />
    );
};

export default Logging;